import { render, staticRenderFns } from "./approval-template-activate-confirmation.vue?vue&type=template&id=558d7e2c&scoped=true&"
import script from "./approval-template-activate-confirmation.vue?vue&type=script&lang=js&"
export * from "./approval-template-activate-confirmation.vue?vue&type=script&lang=js&"
import style0 from "./approval-template-activate-confirmation.vue?vue&type=style&index=0&id=558d7e2c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558d7e2c",
  null
  
)

export default component.exports